import React from 'react';

import './Modal.css';
import { activateOnEnterOrSpace } from '../util/activateOnEnterOrSpace';

function ModalWrapper(props) {
  // Strings are passed through as-is; Modal sanitizes and renders them (CH-3389).
  function openModal() {
    props.onOpenModal(props.modalText);
  }

  return (
    <>
      {props.modalText && (
        <span
          onClick={openModal}
          onKeyDown={activateOnEnterOrSpace(openModal)}
          role="button"
          tabIndex={0}
          aria-haspopup="dialog"
          className="modal_wrapper"
        >
          {props.children}
        </span>
      )}
      {!props.modalText && props.children}
    </>
  );
}
export default ModalWrapper;
